import Mentor from './component';
import _routes from './routes';

export const routes = _routes;

export default Mentor;



// WEBPACK FOOTER //
// ./containers/Group/Homework/Mentor/index.jsx